<div class="cpcontent googlesignin" [hidden]="isAuthenticatedWithFirebase">
    <h5>Signin with Google to access the Firebase database</h5>
    <br>
    <div class="row">
        <div class="col-md-6">
            <button class="btn btn-primary" (click)="signInWithGoogle()">Sign in with Google</button>
        </div>
    </div>
</div>
<div class="cpcontent" [hidden]="!isAuthenticatedWithFirebase">
    <h5>Scenario Edit</h5>
    <!-- Tabs -------------------------------------------------------------------------->
    <div class="container">
        <ul class="nav nav-tabs" id="myTab2" role="tablist">
            <li class="nav-item" role="presentation">
                <a class="nav-link active" id="components-tab" data-bs-toggle="tab" href="#header" role="tab" aria-controls="header" aria-selected="true">Header</a>
            </li>
            <li class="nav-item" role="presentation">
                <a class="nav-link" id="components-tab" data-bs-toggle="tab" href="#players" role="tab" aria-controls="component" aria-selected="true">Players</a>
            </li>
            <li class="nav-item" role="presentation">
                <a class="nav-link" id="json-tab" data-bs-toggle="tab" href="#lessonplan" role="tab" aria-controls="clone" aria-selected="false">
                    Lesson Plan
                </a>
            <li class="nav-item" role="presentation">
                <a class="nav-link" id="json-tab" data-bs-toggle="tab" href="#json" role="tab" aria-controls="clone" aria-selected="false">
                    JSON
                </a>
            </li>
        </ul>
    </div>

    <!-- Content of  Tabs -------------------------------------------------------------------------->
    <div class="tab-content" id="myTab2Content">

        <!-- Header -------------------------------------------------------------------------->
        <div class="tab-pane active show" id="header" role="tabpanel" aria-labelledby="header-tab">
            <h5>
                Header Data
            </h5>
            <div class="row">
                <div class="col-md-6">
                    <sa-input-text [(text)]="scenario.displayName" [title]="'Display Name' "></sa-input-text>
                    <br>
                    <sa-input-text [(text)]="scenario.description" [title]="'Description' "></sa-input-text>
                    <br>
                    <sa-select [(Id)]="worldkey" [title]="'Worlds'" [options]="worldskeys"></sa-select>
                    <br>
                    <button class="btn btn-primary" (click)="updateScenario()">Update</button>
                </div>
                <div class="col-md-6">
                    <h3>Rename Scenario</h3>
                    <sa-input-text [(text)]="newScenarioName" [title]="'New Name' "></sa-input-text>
                    <button class="btn btn-primary" (click)="renameScenario()">Rename</button>

                </div>
            </div>
        </div>

        <!-- Players -------------------------------------------------------------------------->
        <div class="tab-pane fade show" id="players" role="tabpanel" aria-labelledby="header-tab">
            <h5>
                Players
            </h5>
            <table class="table table-bordered">
                <thead>
                    <tr>
                        <th>Name</th>
                        <th>Timestamp</th>
                        <th>Timelapse</th>
                        <th>Delete</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let player of scenario.players  | keyvalue">
                        <td>{{player.key}}</td>
                        <td>{{toAny(player.value).timestamp}}</td>
                        <td>{{toAny(player.value).datetime}}</td>
                        <td><button class="btn btn-warning" (click)="deletePlayer(player.key)">Delete</button></td>
                    </tr>
                </tbody>
            </table>
        </div>

        <!-- lessonplan -------------------------------------------------------------------------->
        <div class="tab-pane fade show" id="lessonplan" role="tabpanel" aria-labelledby="header-tab">
            <h5>
                Lessonplan
            </h5>
                <button class="btn btn-primary" (click)="openModalLessonplanStep(null)">Add Lessonplan Step</button>
                <table class="table table-bordered">
                    <thead>
                        <tr>
                            <th>Name</th>
                            <th>Description</th>
                            <th>Game Assets</th>
                            <th>Edit</th>
                        </tr>
                    </thead>
                    <tr *ngFor="let lessonplanStep of this.scenario.lessonplan">
                        <td>{{lessonplanStep.name}}</td>
                        <td>{{lessonplanStep.description}}</td>
                        <td>{{lessonplanStep.assets}}</td>
                        <td><button class="btn btn-warning" (click)="openModalLessonplanStep(lessonplanStep)">Edit</button></td>
                        <!-- <td><button class="btn btn-warning" (click)="deleteLessonplanStep(lessonplanStep.key)">Delete</button></td> -->
                    </tr>
                </table>     
        </div>
   
        <!-- json -------------------------------------------------------------------------->

        <div class="tab-pane fade show" id="json" role="tabpanel" aria-labelledby="header-tab">
            <h5>JSON</h5>
            {{scenario | json}}
        </div>
    </div>

</div>

<!-- Modal Interactivy---------------------------------------------------------------------------->
<div *ngIf="showModalLessonplanStep" #testmodal class="cpmodal">
    <div class="cpmodal-content" style="max-width:800px;margin-top:5%">
        <h5>Interactivity</h5>
        <sa-input-text [(text)]="lessonplanStep.name" [title]="'Name'"></sa-input-text>
        <sa-input-text [(text)]="lessonplanStep.description" [title]="'Description'"></sa-input-text>
        <sa-input-text [(text)]="lessonplanStep.assets" [title]="'Asset'"></sa-input-text>
        <sa-input-number [(text)]="lessonplanStep.seqno" [title]="'SeqNo' "></sa-input-number>
        <br>
        <button class="btn btn-primary" (click)="updateLessonplanStep()">Update</button>

        <button class="btn btn-primary" style="float:right" (click)="showModalLessonplanStep = false">Close Modal</button>
    </div>
</div>